// extracted by mini-css-extract-plugin
export default {"moreInfoBtn":"moreInfo_moreInfoBtn__w9UaX","moreInfoIcon":"moreInfo_moreInfoIcon__mCbDe"};